import React, { useEffect } from "react";
import { History, Target, Users } from "lucide-react";
import { Helmet } from "react-helmet-async";
export default function About() {
       useEffect(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }, []);
  

    
  return (
    <>
      <Helmet>
        <title>About Us - ANS Safety Nets</title>
        <meta
          name="description"
          content="ANS Safety Nets, a leading provider of high-quality safety nets  in Bengaluru. We specialize in a variety of safety nets for homes, industries, and more."
        />
        <meta
          name="keywords"
          content="safety nets in bengaluru , ans safety nets ,About ANS Safety Nets, Safety Nets in Bengaluru, ANS Safety Nets, safety nets in bengaluru, Safety Solutions, Bengaluru Safety Nets , balcony safety nets in bengaluru , balcony safety nets,pegion safety nets in bengaluru, monkey safety nets in bengaluru,Ducteria Nets in bengaluru, Pets Safety Nets in bengaluru, Industrial Safety Nets in bengaluru, Children Safety Nets in bengaluru, Bird Spikes in , Cricket Practice Nets in bengaluru,Sports Nets,Pigeon Safety Nets,Building covering Net,pigeon Safety Nets, Sports Nets in bengaluru,Pigeon Safety Nets in bengaluru,Building covering Net in bengaluru,pigeon Safety Nets in bengaluru"
        />
        <meta name="author" content="ANS Safety Nets, Bengaluru" />
        <link rel="canonical" href="https://www.anssafetynets.com/about" />
      </Helmet>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "ANS Safety Nets",
          url: "https://www.anssafetynets.com/about",
          logo: "https://www.anssafetynets.com/logo.png", // Replace with actual logo URL
          description:
            "ANS Safety Nets, a leading provider of high-quality safety nets in Bengaluru. We specialize in a variety of safety nets for homes, industries, and more.",
          sameAs: [
            "https://www.facebook.com/profile.php?id=61572534324956",
            "https://www.instagram.com/anssafetynets_bengaluru/",
          ],
          contactPoint: {
            "@type": "ContactPoint",
            telephone: "+91-7416116587",
            contactType: "Customer Service",
            areaServed: "IN",
            availableLanguage: ["English", "Kannada"],
          },
          founder: "ANS Safety Nets",
          keywords: [
            "safety nets in bengaluru",
            "ans safety nets",
            "ans safety nets in bengaluru",
            "balcony safety nets",
            "balcony safety nets in bengaluru",
            "pigeon safety nets",
            "pigeon safety nets in bengaluru",
            "industrial safety nets",
            "industrial safety nets in bengaluru",
            "bird spikes",
            "bird spikes in bengaluru",
            "sports nets",
            "sports nets in bengaluru",
            "building covering nets",
            "building covering nets in bengaluru",
            "pets safety nets",
            "pets safety nets in bengaluru",
            "ducteria nets",
            "ducteria nets in bengaluru",
            "children safety nets",
            "children safety nets in bengaluru",
            "cricket practice nets",
            "cricket practice nets in bengaluru",
          ],
          address: {
            "@type": "PostalAddress",
            streetAddress:
              "74/9, 5th Cross Rd, Muthyala Nagar, Bahubali Nagar, Jalahalli, Bengaluru, Karnataka 560013",
            addressLocality: "Bengaluru",
            addressRegion: "KA",
            postalCode: "560013",
            addressCountry: "IN",
          },
          service: [
            {
              "@type": "Service",
              name: "Balcony Safety Nets",
              areaServed: "Bengaluru",
            },
            {
              "@type": "Service",
              name: "Children Safety Nets",
              areaServed: "Bengaluru",
            },
            {
              "@type": "Service",
              name: "Pets Safety Nets",
              areaServed: "Bengaluru",
            },
            {
              "@type": "Service",
              name: "Industrial Safety Nets",
              areaServed: "Bengaluru",
            },
            {
              "@type": "Service",
              name: "Monkey Safety Nets",
              areaServed: "Bengaluru",
            },
            {
              "@type": "Service",
              name: "Cricket Practice Nets",
              areaServed: "Bengaluru",
            },
            {
              "@type": "Service",
              name: "Bird Spikes",
              areaServed: "Bengaluru",
            },
          ],
        })}
      </script>
      <div className="pt-16">
        {/* Hero Section */}
        <div className="bg-[#2c3639] py-20">
          <div className="max-w-7xl mx-auto px-4 text-center">
            <h1 className="text-4xl font-bold text-white mb-4">About Us</h1>
            <p className="text-xl text-gray-400">
              Protecting lives, property, and peace of mind with reliable safety
              solutions tailored to every need.
            </p>
          </div>
        </div>

        {/* Company Story */}
        <div className="py-20">
          <div className="max-w-7xl mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-3xl font-bold mb-6">Our Story</h2>
                <p className="text-gray-600 mb-4">
                  <strong>At ANS Safety Nets,</strong> we are a premier provider
                  of safety nets in Bengaluru, offering top-quality solutions
                  tailored to residential, commercial, and industrial needs.
                  Renowned for our reliable and durable safety nets, we
                  specialize in creating customized solutions to ensure maximum
                  security for homes, businesses, and industries across
                  Bengaluru.
                </p>
                <i className="text-gray-900">
                  Our expertise lies in delivering a wide range of safety nets
                  designed to meet diverse requirements, including:
                </i>
                <p className="mt-2">
                  <strong>Balcony Safety Nets in Bengaluru : </strong>
                  Safeguard your balconies while maintaining aesthetics.
                </p>
                <p className="mt-1">
                  <strong>Children Safety Nets in Bengaluru : </strong>
                  Protect your little ones from potential falls, ensuring a safe
                  environment.
                </p>
                <p className="mt-1">
                  <strong>Pets Safety Nets in Bengaluru : </strong>
                  Keep your pets safe and secure without restricting their
                  movement.
                </p>
                <p className="mt-1">
                  <strong>Industrial Safety Nets in Bengaluru : </strong>
                  Enhance workplace safety with our durable and reliable nets.
                </p>
                <p className="mt-1">
                  <strong>Ducteria Nets in Bengaluru : </strong>
                  Specialized solutions for duct areas to ensure safety.
                </p>
                <p className="mt-1">
                  <strong>Monkey Safety Nets in Bengaluru : </strong>
                  Prevent monkey invasions and protect your premises
                  effectively.
                </p>
                <p className="mt-1">
                  <strong>Cricket Practice Nets in Bengaluru : </strong>
                  Perfect for sports enthusiasts looking for high-quality
                  practice nets.
                </p>
                <p className="mt-1">
                  <strong>Bird Spikes in Bengaluru : </strong>
                  Keep your spaces free from bird-related issues with our
                  durable bird spikes.
                </p>

                <i className="text-gray-900">Trusted Name in Safety Nets</i>

                <p>
                  At <strong>ANS Safety Nets</strong>, we are not just providers
                  of safety solutions; we are partners in creating a safer
                  community. Our passion for innovation, commitment to quality,
                  and focus on customer satisfaction have made us the trusted
                  choice for those seeking reliable safety nets in Bengaluru.
                  Whether you need Balcony Safety Nets, Children Safety Nets, or
                  Cricket Practice Nets, our goal is to deliver the best safety
                  solutions tailored to your needs. Experience unmatched quality
                  and service with ANS Safety Nets—your trusted partner for a
                  safer, more secure future.
                </p>
              </div>
              <div>
                <img
                  src="https://i.pinimg.com/736x/3c/9b/24/3c9b24af8f31aa8ea6ae20a609e3a9a0.jpg"
                  alt="ANS SAFETY NETS ,safety nets in bengaluru,"
                  tittle="ANS SAFETY NETS ,safety nets in bengaluru,safety nets, no 01 safety nets Balcony Safety Nets,
  Children Safety Nets,
  Industrial Safety Nets,
  Pets Safety Nets,
  Ducteria Nets,
  Monkey Safety Nets,
  Cricket Practice Nets,
  Bird Spikes"
                  className="rounded-lg shadow-lg h-[600px] w-[100%] object-cover"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Values Section */}
        <div className="bg-gray-50 py-10">
          <div className="max-w-7xl mx-auto px-4">
            <h2 className="text-3xl font-bold text-center mb-8">
              Our Core Values
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {[
                {
                  icon: History,
                  title: "Excellence",
                  description:
                    "We strive for excellence in everything we do, from product quality to customer service.",
                },
                {
                  icon: Target,
                  title: "Innovation",
                  description:
                    "Continuously improving our products and services through innovative solutions.",
                },
                {
                  icon: Users,
                  title: "Customer Focus",
                  description:
                    "Our customers' needs and satisfaction are at the heart of our business.",
                },
              ].map((value, index) => (
                <div
                  key={index}
                  className="bg-[#d8d9dd] p-6 rounded-lg shadow-md hover:translate-y-[-10px] transition-transform duration-300 ease-in-out cursor-pointer"
                >
                  <value.icon className="h-12 w-12 text-[#2c3639] mb-4 " />
                  <h3 className="text-xl font-semibold mb-2">{value.title}</h3>
                  <p className="text-gray-600">{value.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
